module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-box"
  }, [_c('div', {
    class: [_vm.flag ? 'plugin-arrow-legend' : 'top-arrow-legend'],
    on: {
      "click": _vm.hiddenLegend
    }
  }), _vm._v(" "), (_vm.show) ? _c('div', {
    ref: "legendContainer",
    staticClass: "legend-container"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e03f5d10"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/map_module/maptool/legend.vue
// module id = 15
// module chunks = 0